import { Col, Container, Row } from 'reactstrap';
import UsageTransferMetricCard from './UsageTransferMetricCard';
import UsageTransferMetricValue from './UsageTransferMetricValue';
import './UsageTransferMetricCard.css';

type UsageTransferMetricValues = {
  moveItems: string | number
  savedAmount: string | number
  expiringItems: string | number
  wastedAmount: string | number
}

type UsageTransferMetricsViewProps = {
    values: UsageTransferMetricValues
    isLoading ?: boolean
}

const UsageTransferMetricsView = ({
  values,
  isLoading
}: UsageTransferMetricsViewProps) => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <UsageTransferMetricCard color='green'>
                        <UsageTransferMetricValue title='What Can I Move?' value={values.moveItems} isLoading={isLoading} />
                        <div className='metric-divider' />
                        <UsageTransferMetricValue
                            title='How Much Will Be Saved?'
                            value={values.savedAmount}
                            isMoney
                            isLoading={isLoading}
                        />
                    </UsageTransferMetricCard>
                </Col>

                <Col>
                    <UsageTransferMetricCard color='orange'>
                        <UsageTransferMetricValue title='What Expires Soon?' value={values.expiringItems} isLoading={isLoading} />
                        <div className='metric-divider' />
                        <UsageTransferMetricValue
                            title='How Much Will Be Wasted?'
                            value={values.wastedAmount}
                            isMoney
                            isLoading={isLoading}
                        />
                    </UsageTransferMetricCard>
                </Col>
            </Row>
        </Container>
    );
};
export default UsageTransferMetricsView;
